import { IQueryTerms } from './q';
import { FieldFilter } from '../DataTypes';

function addCustomFilter<T>(w: IQueryTerms<T>, f: FieldFilter) {
  const field = f?.field as any;
  const customFilters = [] as any[];
  if (!field) return customFilters;
  const filtersToAdd =
    w.term(field, f.eq) ||
    w.multi_match(field, f.match) ||
    w.match_bool_prefix(field, f.startsWith) ||
    w.terms(field, f.in) ||
    w.range(field, { lt: f.lt }) ||
    w.range(field, { lte: f.lte }) ||
    w.range(field, { gt: f.gt }) ||
    w.range(field, { gte: f.gte }) ||
    (f.between ? w.between(field, f.between.lower, f.between.upper) : undefined) ||
    (f.notBetween && (f.notBetween.lower || f.notBetween.upper)
      ? w.bool((bq) =>
          bq.must_not((qt) => [qt.between(field, f.notBetween!.lower, f.notBetween!.upper) as Record<string, unknown>]),
        )
      : undefined) ||
    (f.intersects
      ? w.intersects(f.intersects.lowerField as any, f.intersects.upperField as any, f.intersects.lower, f.intersects.upper)
      : undefined) ||
    (f.raw ? w.raw(f.raw.value) : undefined) ||
    (f.contains ? w.contains(f.contains.lowerField as any, f.contains.upperField as any, f.contains.value) : undefined) ||
    (f.notIntersects?.lowerField && f.notIntersects.upperField && (f.notIntersects.lower || f.notIntersects.upper)
      ? w.bool((bq) =>
          bq.must_not((qt) => [
            qt.intersects(
              f.notIntersects!.lowerField as any,
              f.notIntersects!.upperField as any,
              f.notIntersects!.lower,
              f.notIntersects!.upper,
            ),
          ]),
        )
      : undefined) ||
    (f.ne !== null && f.ne !== undefined ? w.bool((bq) => bq.must_not((qt) => [qt.term(field, f.ne)])) : undefined) ||
    (f.nin ? w.bool((bq) => bq.must_not((qt) => [qt.terms(field, f.nin)])) : undefined);

  if (filtersToAdd) {
    customFilters.push(filtersToAdd);
  }

  return customFilters.flat();
}

function getReferenceFieldIdx(field: string | undefined): number {
  return field?.indexOf(':r') ?? -1;
}

export default function addESCustomFilters<T>(w: IQueryTerms<T>, fields: FieldFilter[]) {
  if (!fields) return [];
  return fields.reduce((prev, current) => {
    const field = current.field as any;
    if (!field) return prev;
    const refIndex = getReferenceFieldIdx(field);
    if (refIndex > 0) {
      prev.push(
        w.nested(field.substring(0, refIndex + 2), (x) => x.bool((z) => z.filter((filter) => addCustomFilter<T>(filter, current)))),
      );
    } else {
      prev.push(...addCustomFilter(w, current));
    }
    return prev;
  }, [] as any[]);
}
